module.exports = __webpack_public_path__ + "img/pdf_head01.75a5dd51.jpg";